import { AppData } from '@lightningjs/sdk';
import { generateUUIDv4 } from 'support/generalUtils';

type AdobePassParams = { baseUrl: string };
export default class AdobePassService {
  static readonly serviceName = 'AdobePassService';

  private baseUrl = '';
  private deviceId = '';
  private _profile = {}; // AuthN

  constructor(params: AdobePassParams) {
    this.baseUrl = params.baseUrl;
  }

  get profile() {
    return this._profile;
  }

  set profile(profile) {
    this._profile = profile;
  }

  // Unique for Adobe
  private getAdobeDeviceId() {
    if (!this.deviceId) {
      // TODO: Storage cache
      this.deviceId = generateUUIDv4();
    }

    return this.deviceId;
  }

  private sendRequest() {
    // Unsecure register/token requests
  }

  private sendSecureRequest() {
    // All other requests
  }

  private logDebug(message: string) {
    AppData?.log.debug(`[${AdobePassService.serviceName}]`, message);
  }

  async init() {
    try {
      await this.getRegistration();
      await this.getAccessToken();
      await this.checkProfile();
    } catch (e) {
      // TODO: Error handling
      this.logDebug('TODO: Adobe Pass initialize error');
    }

    this.logDebug('Initialized');
  }

  getRegistration() {
    return Promise.resolve();
  }

  getAccessToken() {
    return Promise.resolve();
  }

  createSession() {
    return Promise.resolve();
  }

  checkProfile() {
    this.profile = {}; // TODO: Set profile
    return Promise.resolve();
  }

  checkProfileByCode(code: string) {
    this.profile = {}; // TODO: Set profile
    return Promise.resolve();
  }

  checkAuthorization() {
    return Promise.resolve();
  }

  logout() {
    return Promise.resolve();
  }
}
